export default "__VITE_ASSET__DM6M8thi__"